<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>공지사항 등록 기본정보</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">등록일</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{noticeDatas.reg_date}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">노출여부</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">
                        <b-form-radio-group id="basicCustomUseyn" name="useyn">
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="useY" name="useyn" disabled class="custom-control-input" v-model="noticeDatas.use_yn" value="Y">
                            <label class="custom-control-label" for="useY">노출</label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="useN" name="useyn" disabled class="custom-control-input" v-model="noticeDatas.use_yn" value="N">
                            <label class="custom-control-label" for="useN">비노출</label>
                          </div>
                        </b-form-radio-group>
                      </label>
                    </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">공지여부</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">
                        <b-form-radio-group id="basicCustomTopyn" name="topyn">
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="topY" name="topyn" disabled class="custom-control-input" v-model="noticeDatas.top_yn" value="N">
                            <label class="custom-control-label" for="topY">일반공지</label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="topN" name="topyn" disabled class="custom-control-input" v-model="noticeDatas.top_yn" value="Y">
                            <label class="custom-control-label" for="topN">상단공지</label>
                          </div>
                        </b-form-radio-group>
                      </label>
                    </td>
                  </tr>
                  
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">제목</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{noticeDatas.subject}}</td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">내용</label>
                    </td>
                    <td class="" style="vertical-align:middle"><div v-html="noticeDatas.contents"></div></td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">첨부파일(PDF)</label>
                    </td>
                    <td class="" colspan="4">
                      <div v-show="noticeDatas.attachmentFileItems.length == 0">
                        <label class="col-form-label">등록된 파일이 없습니다.</label>
                      </div>
                      <b-col md="6" style="margin-left:-13px">
                        <div class="list-group">
                        	<li class="list-group-item" v-for="(attachmentFile, idx) in noticeDatas.attachmentFileItems" style="padding: 0px 0px 10px 10px;">
                            <label class="col-form-label">
                              <i :class="'fa-file-'+attachmentFile.file_extensions+'-o'" class="fa fa-2x mt-1 bg-danger"></i>
                              {{attachmentFile.file_originalname}} ({{attachmentFile.filesizeStr}})
                        			<p class="fileurl" style="display: none;">{{attachmentFile.file_url}}</p>
                            </label>
                          </li>
                        </div>
                      </b-col>
                    </td>
                  </tr>
                </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4">
                  <b-button variant="danger" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #f42f2d; font-size:15px" v-on:click="drNoticeDelete(noticecode)"><h5 style="margin-bottom:0px"><i class="fa fa-remove"></i> 삭제</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="warning" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #c5940d; font-size:15px" v-bind:href="'#/customer/notice/form?status=update'"><h5 style="margin-bottom:0px"><i class="fa fa-edit"></i> 수정</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/customer/notice'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import cSwitch from '../../components/Switch';
import swal from 'sweetalert2'

export default {
  components: {
    cSwitch,
  },
  data() {
    return {
      noticecode: '',
      drDeleteRows: [],
      noticeDatas: {
        attachmentFileItems:[],
      },
    }
  },
  watch: {},
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.noticecode = self.$session.get('noticeCode');
    // ### 리포트 정보 불러오기 ###
    // 리포트정보를 DB테이블에서 조회
    // 최초작성 : 2016.05.31
    // 파라미터 : newslettercode
    //  - newslettercode
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    if(self.noticecode != undefined){
      self.getDrNoticeData(self.noticecode);
    }
  },
  methods: {
    // 메소드명 : getDrNoticeData(val)
    // ### 리포트 데이터 갱신 ###
    // 메소드 저장후 데이터 갱신용으로 사용
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - val(해당 필드의 value 값을 가져옴)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.06.10  황경현   최초작성
    // *************************
    getDrNoticeData(noticecode) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.$http.get('/api/select/drNoticeData?access_token=' + token + '&noticecode=' + noticecode)
      .then((result) => {
        result.data.attachmentFileItems.forEach(function (t_el, t_idx, t_arr){
          if(t_el.file_extensions == 'png' || t_el.file_extensions == 'jpg'){
            t_el.file_extensions = 'image';
          }
        });

        self.noticeDatas = result.data;
      })
    },
    drNoticeDelete(drCodeDel){
      var self = this;
      self.drDeleteRows = [];
      swal.fire({
        title: '공지사항 삭제!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: "현재 공지사항의 저장된 데이터</br> 모두 삭제 됩니다. 삭제하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          // ok
          self.drDeleteRows.push(drCodeDel);
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.drDeleteRows));
          var data = new FormData();
          data.append('drDelArr', param);

          self.$http.post('/api/delete/drNotice?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '공지사항이 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                  window.location = "#/customer/notice";
              });
          })
        }else{
          // cansel
        }
      })
    }
  }
}

$(document).ready(function(){
	var xOffset = 50;
  var yOffset = 10;
  $(document).on("mouseover",".imgview label",function(e){ //마우스 오버시
      $("body").append("<p id='preview'><img src='"+ $(this).attr("data") +"' /></p>"); //보여줄 이미지를 선언
      $("#preview")
          .css("position","absolute")
          .css("top",(e.pageY - xOffset) + "px")
          .css("left",(e.pageX + yOffset) + "px")
          .fadeIn("fast"); //미리보기 화면 설정 셋팅
  });
  $(document).on("mousemove",".imgview label",function(e){ //마우스 이동시
      $("#preview")
          .css("top",(e.pageY - xOffset) + "px")
          .css("left",(e.pageX + yOffset) + "px");
  });
  $(document).on("mouseout",".imgview label",function(){ //마우스 아웃시
      $("#preview").remove();
  });
});
</script>



// WEBPACK FOOTER //
// src/views/customer/NoticeInfo.vue